import { render, staticRenderFns } from "./blog-whatsapp-vs-aero.vue?vue&type=template&id=0ebd039e"
import script from "./blog-whatsapp-vs-aero.vue?vue&type=script&lang=js"
export * from "./blog-whatsapp-vs-aero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports